module.exports = __webpack_public_path__ + "img/treasure_box_open.95865b89.svg";